var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.974731,
    width: 46.9873,
    height: 26.0958,
    rx: 2.20253,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5007 5.74561H28.9872V20.9944H20.5007V5.74561Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0396 13.3698C21.0396 10.2716 22.4944 7.5235 24.7304 5.74533C23.0871 4.45217 21.0127 3.6709 18.7497 3.6709C13.3881 3.6709 9.05066 8.00838 9.05066 13.3698C9.05066 18.731 13.3881 23.0686 18.7495 23.0686C21.0126 23.0686 23.087 22.2874 24.7304 20.9941C22.4944 19.2429 21.0396 16.468 21.0396 13.3698V13.3698Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4372 13.3698C40.4372 18.731 36.0997 23.0686 30.7383 23.0686C28.4753 23.0686 26.4009 22.2874 24.7574 20.9941C27.0205 19.216 28.4484 16.468 28.4484 13.3698C28.4484 10.2716 26.9935 7.5235 24.7574 5.74533C26.4007 4.45217 28.4753 3.6709 30.7383 3.6709C36.0997 3.6709 40.4373 8.03538 40.4373 13.3698H40.4372Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardlogo);
export default __webpack_public_path__ + "static/media/mastercardlogo.26ed56b5a374bcf4db926b87da9728c2.svg";
export { ForwardRef as ReactComponent };